import React from "react";
import { Helmet } from "react-helmet";
import CardMenu from "../cardMenu";
import CardContent from "./cardContent";
import CardEditHeader from "../cardHeader";


const CardUpdate = () => {
    return (
        <div className="card-edit-wrapper">
            <Helmet><title>Card Update</title></Helmet>
            <CardEditHeader />
            <div className="ces-wrapper">
                <CardMenu />
                <CardContent />
            </div>
        </div>
        
    );
}

export default CardUpdate;
